import { Grid } from "@mui/material";
import { postAdd } from "Apis/post";
import MDBox from "components/MDBox";
import TinyTextEditor from "components/MDTinyTextEditor";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { useFormik } from "formik";
import React, { useContext, useState, useEffect } from "react";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { updatePost } from "Apis/post";
import MDSelectBox from "components/MDSelectBox";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import MDInput from "components/MDInput";

const PostForm = ({ handlePostList }) => {
  const { setNotification, postEditData } = useContext(LoginFormContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });

  const { setOpen, formIsEdit } = useContext(ModalContext);
  const initialValues = {
    description: "",
    title: "",
    is_active: 0,
  };
  const validationSchema = Yup.object().shape({
    description: Yup.string().required("Description is required!"),
    title: Yup.string().required("Title is required!"),
    is_active: Yup.string().required("Status is required!"),
  });

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  useEffect(() => {
    if (formIsEdit) {
      setStatus({ label: getStatusLabel(postEditData?.is_active), value: postEditData?.is_active });
    }
  }, []);

  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await postAdd(values);
      if (response?.status === 200) {
        handlePostList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editData = await updatePost(values);
      if (editData?.status === 200) {
        handlePostList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editData.data.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editData.data.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const formik = useFormik({
    initialValues: formIsEdit ? postEditData : initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <MDBox>
      <Grid item xs={12} md={12} component="form" role="form" onSubmit={formik.handleSubmit}>
        {/* Title */}
        <Grid item xs={12} md={6} mb={3}>
          <MDInput
            type="text"
            name="title"
            value={formik.values.title}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Title"
            sx={{ width: "100%" }}
            variant="standard"
            required
          />
          {formik.touched.title && formik.errors.title && (
            <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
              {formik.errors.title}
            </MDBox>
          )}
        </Grid>

        <MDBox sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "5px", marginTop: "10px" }}>
          Description (પોસ્ટની વિગતો) <span style={{ color: "red" }}>*</span>
        </MDBox>
        <TinyTextEditor
          setContent={(value) => formik.setFieldValue("description", value)}
          content={formik.values.description}
          onBlur={formik.handleBlur}
          folderName={"/post"}
        />
        {formik.touched.description && formik.errors.description && (
          <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
            {formik.errors.description}
          </MDBox>
        )}

        {/* status */}
        <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
          <MDSelectBox
            name="is_active"
            defaultValue={status}
            options={statusData}
            handleChange={(value) => handleStatusChange(value)}
            label="Status"
            width="100%"
            multiple={false}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.is_active && formik.errors.is_active && (
            <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
              {formik.errors.is_active}
            </MDBox>
          )}
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </Grid>
    </MDBox>
  );
};
PostForm.propTypes = {
  handlePostList: PropTypes.func,
};
export default PostForm;
